import axios from "../http/axios";
import { PORTAL_SERVICOS_BACKEND } from "../constants/environment";

const BASE_URL_SERVICO = `${PORTAL_SERVICOS_BACKEND}/frontend/v1/formulario-servico`;

export default {
	urlFormularioServico: (codigo, token) => {
		const tokenValue = token ? `/?access_token=${token}` : ``;
		const params = `${codigo}${tokenValue}`;
		return axios.get(`${BASE_URL_SERVICO}/${params}`).then(res => {
			return res.data;
		});
	}
};
